export default "__VITE_ASSET__Ctvw1O2N__"